import { useLingui } from '@lingui/react';
import { useLocation } from 'react-router-dom';
import PdfPreview from '../../Molecules/Document/PdfPreviewNew';
import { IconX } from '@tabler/icons';
import { ActionIcon, Box, Text } from '@mantine/core';
import EmailAttachmentChip from './EmailAttachmentChip';

const EmailDocumentAttachment = ({ eventId, attachment, deleteAtIndex, index }) => {
  const { i18n } = useLingui();
  const { pathname } = useLocation();
  const showDocumentPreview = !pathname.includes('emails');
  const previewAttachment = showDocumentPreview
    ? { ...attachment, fileName: i18n._(`document.${attachment.documentType.toLowerCase()}`) }
    : attachment;

  return (
    <EmailAttachmentChip>
      {showDocumentPreview && (
        <Box sx={{ flex: '0 1 auto', minWidth: 0, maxWidth: '100%', overflow: 'hidden' }}>
          <PdfPreview file={previewAttachment} eventId={eventId} fileNameWidth={200} fileNameSize="xs" />
          {attachment.templateName && (
            <Text
              size="xs"
              color="dimmed"
              lineClamp={1}
              sx={{
                maxWidth: 200,
                minWidth: 0,
                boxSizing: 'border-box',
                paddingLeft: 20,
                lineHeight: 1.2,
              }}
            >
              Vorlage: {attachment.templateName}
            </Text>
          )}
        </Box>
      )}

      {deleteAtIndex && (
        <ActionIcon size="xs" sx={{ flex: '0 0 auto' }} title="Anhang entfernen" onClick={() => deleteAtIndex(index)}>
          <IconX />
        </ActionIcon>
      )}
    </EmailAttachmentChip>
  );
};

export default EmailDocumentAttachment;
